import i18n from "./locale/i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Toaster } from "sonner";
import { I18nextProvider } from "react-i18next";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n} defaultNS={"translation"}>
      <App />
    </I18nextProvider>
    <Toaster position="bottom-center" reverseOrder={false} richColors={true} />
  </React.StrictMode>
);
